import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import DarkShsLogo from '../../../resources/Dark_SHS_Logo.png';
import './Footer.scss';

class Footer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="FooterContainer">
        <Grid>
          <Row>
            <hr className="divider" />
            <Col xsHidden smHidden md={4} lg={4} className="ShsLogo">
              <img src={DarkShsLogo} alt="Smart Home Support By Asurion" />
            </Col>
            <Col xs={12} sm={6} md={4} lg={4} className="links">
              <a className="faq" href="https://www.smarthomesupport.com/frequently-asked-questions/">
                FAQ
              </a>
              <a className="conditions" href="https://www.asurion.com/terms-conditions/">
                TERMS AND CONDITIONS
              </a>
            </Col>
            <Col xs={12} sm={6} md={4} lg={4} className="copyright">
              &copy; 2019 SMART HOME SUPPORT BY ASURION
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (/*state, ownProps*/) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/shs/Footer/Footer.js